import styled from "@emotion/styled";
import React from "react";
import { useTranslation } from "react-i18next";

import sessionForm1 from "@assets/pdfs/Form_Session1.pdf";
import sessionForm2 from "@assets/pdfs/Form_Session2.pdf";
import sessionManual from "@assets/pdfs/QMS1-44564529-120123-1141.pdf";

import DateComponent from "@components/Date";
import PdfFormsModal from "@components/PdfFormsModal";
import UserManualModal from "@components/UserManualModal";

import { globalTextColors } from "@constants/colors";

import { Typography } from "@mui/material";

const BAScreen = () => {
  const { t } = useTranslation();
  return (
    <div className="py-48">
      <Title variant="h4">PDF-filer</Title>
      <DateComponent />
      <SubTitle>Klicka på en fil för att öppna, ladda ner och printa.</SubTitle>

      <div className="flex ">
        <div>
          <Typography sx={{ fontSize: "16px", fontWeight: "700" }}>
            Manual
          </Typography>
          <UserManualModal type="ba" />
        </div>
      </div>

      <Typography
        sx={{ margin: "1.6rem 0px", fontSize: "16px", fontWeight: "700" }}
      >
        {t("Bilagor")}
      </Typography>
      <div className="flex flex-row gap-8">
        <PdfFormsModal
          pdfPath={sessionManual}
          title="BADTR & Zeeds Session mapping"
        />
        <PdfFormsModal pdfPath={sessionForm1} title="Formulär 1" />
        <PdfFormsModal pdfPath={sessionForm2} title="Formulär 2" />
      </div>
    </div>
  );
};

const Title = styled(Typography)({
  color: globalTextColors.PRIMARY,
  fontWeight: "700",
});

const SubTitle = styled(Typography)({
  maxWidth: "55%",
  fontSize: "15px",
  fontWeight: "400",
  margin: "12px 0px 20px",
  color: globalTextColors.SECONDARY,
});

export default BAScreen;
